"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDialogs = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _App = _interopRequireDefault(require("./App"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mountEventName = 'dialog-popup';

var mountApp = function mountApp(id, bus) {
  var mountNode = document.getElementById(id);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_App.default, {
    bus: bus
  }), mountNode);
};

var initDialogs = function initDialogs(bus) {
  var onEvent = function onEvent(_ref) {
    var type = _ref.type,
        payload = _ref.payload;

    if (type === 'mount' && payload.name === mountEventName) {
      mountApp(payload.id, bus);
    }
  };

  bus.subscribe(onEvent);
};

exports.initDialogs = initDialogs;